module.exports = __webpack_public_path__ + "img/life-sciences.c7e10758.svg";